<template>
  <div :style="getElementStyle" v-if="data.properties.filed_content != 'Hide'">
    <el-row>
      <el-col
        v-if="!data.properties.hideLabel"
        :span="showLabel && !isDefalutPos ? 8 : data.description ? 20 : 24"
        :style="computedStyles"
        class="!mb-0.5"
      >
        <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
        <label
          class="!text-LabelSize !font-LabelWeight !text-label-color"
          for="text"
          v-if="hasLabel && !fromRepeatable && data.properties.filed_content != 'Hide'"
          :style="getLabelStyles"
        >
          {{ label || data.label }}

          <span
            v-if="data.validations.required && hasLabel && !isView"
            style="color: red; font-weight: bold"
          >
            *
          </span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </label>
      </el-col>
      <el-col :span="showLabel && !isDefalutPos ? 12 : 24">
        <div v-if="!isView && data.properties.filed_content != 'Hide'" id="checkboxGrpExicute">
          <el-checkbox-group
            v-model="form[data.key]"
            :disabled="checkReadonly() || readonly()"
            :change="changeField"
            @change="applyFormRules"
            :max="getMaxValue"
            class="custom-checkbox !text-DataSize !font-DataWeight !text-data-color"
          >
            <ol :class="data.view_type === true ? 'verticalView' : 'horizontalViewSty'">
              <li
                v-for="(option, index) of options"
                :key="index"
                :class="
                  data.view_type === true ? 'checkbox-option' : 'horizontalView checkbox-option'
                "
              >
                <el-checkbox
                  :value="option"
                  :label="option"
                  border
                  style="margin-left: 5px; margin-top: 5px"
                >
                  {{ option }}
                </el-checkbox>
              </li>
            </ol>
          </el-checkbox-group>
        </div>
      </el-col>
    </el-row>

    <p v-if="missingKeys.includes('' + data.key)" style="color: red; font-size: 14px">
      {{ data.label }} is Required
    </p>

    <p v-if="getIsMobile && isView && data.properties.filed_content != 'Hide'" class="execute-view">
      <template>
        <ul v-if="data.view_type" class="verticalView">
          <li
            class="!text-DataSize !font-DataWeight !text-data-color"
            v-for="(option, index) in options"
            :key="index"
            :class="{
              'selected-option': form[data.key] && form[data.key].includes(option),
              'disabled-option': form[data.key] && !form[data.key].includes(option),
            }"
            style="list-style: none; padding: 5px; margin-bottom: 5px"
          >
            {{ option }}
          </li>
        </ul>
        <span v-else>
          {{ form[data.key] && form[data.key].length ? form[data.key].join(', ') : '-' }}
        </span>
      </template>
    </p>

    <div v-if="!getIsMobile && isView && data.properties.filed_content != 'Hide'">
      <el-checkbox-group
        v-model="form[data.key]"
        disabled
        id="checkboxGrpExicute"
        class="custom-checkbox view-checkbox !text-DataSize !font-DataWeight !text-data-color"
      >
        <ol :class="data.view_type ? 'verticalView' : 'horizontalViewSty'">
          <li
            class="!text-DataSize !font-DataWeight !text-data-color"
            v-for="(option, index) in options"
            :key="index"
            :class="[
              data.view_type ? 'checkbox-option' : 'horizontalView checkbox-option',
              form[data.key] && form[data.key].includes(option) ? 'view-checked' : 'view-unchecked',
            ]"
          >
            <el-checkbox
              class="!text-DataSize !font-DataWeight !text-data-color"
              :label="option"
              :value="option"
              border
              style="margin-left: 5px"
            >
              {{ option }}
            </el-checkbox>
          </li>
        </ol>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  import userPermissionsHelper from '@/mixins/userPermissionsHelper';
  import { bus } from '../../../main';
  import { mapGetters } from 'vuex';

  export default {
    mixins: [userPermissionsHelper],
    components: {},
    props: [
      'data',
      'country',
      'label',
      'form',
      'fromRepeatable',
      'isView',
      'hasLabel',
      'selectedEntityDataId',
      'isFromDocument',
      'checkIsDisabled',
      'colorFields',
      'fromEntityViews',
      'isIconRequired',
    ],
    data() {
      return {
        validations: [],
        options: [],
        missingKeys: [],
        showLabel: true,
        isDefalutPos: true,
        localValue: [],
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),

      computedStyles() {
        const styles = {};
        styles.display = 'flex';
        if (this.data?.styles?.labelAlignments) {
          styles.justifyContent = this.data.styles.labelAlignments;
        }
        return styles;
      },
      getMaxValue() {
        if (this.form && this.form[this.data.key + '/max_value']) {
          return this.form[this.data.key + '/max_value'];
        }
        return this.data.max_selection || undefined;
      },
      getStyle() {
        return this.hasLabel
          ? `height:${this.data.height - 5}px;width:${this.data.width - 5}px;`
          : '';
      },
      getElementStyle() {
        let borderStyle = '';
        if (this.data.styles) {
          let type = this.data.styles.border_type ? this.data.styles.border_type : 'solid';
          let size = this.data.styles.border_size ? this.data.styles.border_size + 'px' : '0px';
          let color = this.data.styles.border_color ? this.data.styles.border_color : '';
          let font_size =
            this.data.styles && this.data.styles.font && this.data.styles.font.font_size
              ? this.data.styles.font.font_size
              : '';
          let bold =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
              ? 'bold'
              : '';
          let italic =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
              ? 'italic'
              : '';

          borderStyle = 'border:' + type + ' ' + ' ' + size + ' ' + color;

          borderStyle += ';';
          borderStyle += this.data.styles.background
            ? `background: ${this.data.styles.background}`
            : '';
          borderStyle += ';';
          borderStyle += this.data.styles.label_color
            ? `color: ${this.data.styles.label_color}`
            : '';
          borderStyle += ';';
          borderStyle += 'font-size:' + font_size + 'px;';
          if (bold) {
            borderStyle += 'font-weight:' + bold + ';';
          }
          if (italic) {
            borderStyle += 'font-style:' + italic + ';';
          }
        }
        return borderStyle;
      },
      // getStyle() {
      //   let style = this.hasLabel ? `height:${this.data.height - 30}px;` : "";
      //   style =
      //     style +
      //     (this.missingKeys.includes("" + this.data.key)
      //       ? `border: 1px solid red;border-radius: 5px; font-size: 14px;`
      //       : "");
      //   return style;
      // },
    },

    mounted() {
      this.options = this.data.options;
      if (
        !this.form[this.data.key] ||
        typeof this.form[this.data.key] !== 'object' ||
        !this.form[this.data.key].length
      ) {
        this.$set(this.form, this.data.key, []);
      }
      bus.$on('missingRequiredFields', (data) => {
        this.missingKeys = data;
      });
    },
    methods: {
      changeField() {
        this.$set(this.form, this.data.key, !this.form[this.data.key]);
      },
      applyFormRules() {
        this.$emit('applyFormRules');
      },
      readonly() {
        if (
          this.data &&
          this.data.properties &&
          this.data.properties.filed_content === 'READ ONLY'
        ) {
          return true;
        }
      },
      checkReadonly() {
        if (this.checkIsDisabled) {
          return true;
        }
        if (this.fieldFilledByCurrentUser(this.data.filled_by) === 'false') {
          if (this.data.styles && this.data.styles.labelStyle) {
            if (this.data.styles.labelStyle == 'hide') {
              this.showLabel = false;
            }
            if (this.data.styles.labelStyle == 'right') {
              this.isDefalutPos = false;
            }
          }
          return !this.fieldFilledByCurrentUser(this.data.filled_by);
        } else {
          if (
            this.data &&
            this.data.properties &&
            this.data.properties.filed_content === 'DISABLED'
          ) {
            return true;
          }
          return !this.fieldFilledByCurrentUser(this.data.filled_by);
        }
      },

      valueChange() {
        // bus.$emit("updatedActionFormData", this.form);
        // bus.$emit("updatedFormData", this.form);
        // if (this.form[this.data.key]) {
        //   let formIndex = this.missingKeys.findIndex((e) => e === this.data.key);
        //   this.missingKeys.splice(formIndex, 1);
        // }
        this.$set(this.form, this.data.key, !this.form[this.data.key]);
      },
    },
  };
</script>

<style lang="scss">
  .checkbox-option {
  }

  // .el-checkbox-group {
  //   font-size: 0;
  //   display: flex;
  //   flex-wrap: wrap;
  // }
  // .check {
  //   margin-top: -2px !important;
  // }
  .GroupBox {
    height: 74px !important;
  }

  .horizontalView {
    display: inline-block;
    padding: 0px;
    margin: 2px 16px 0 0 !important;
  }

  .custom-checkbox .el-checkbox__input .el-checkbox__inner {
    border-color: #333333 !important;
  }

  .execute-view {
    font-weight: normal !important;
  }
</style>
<style scoped>
  .verticalView {
    position: relative;
    right: 25px !important;
  }

  .selected-option {
    margin-left: 20px;
    font-weight: 500;
    color: #1890ff !important;
  }

  .disabled-option {
    margin-left: 20px;
    color: #999999;
    pointer-events: none;
  }

  .horizontalViewSty {
    display: inline-block;
    /* margin-right: 10px; */
    padding: 0px;
  }

  .view-checkbox .el-checkbox__input.is-disabled + .el-checkbox__label {
    cursor: default;
  }

  .view-checked .el-checkbox {
    border: 0;
    background: transparent;
  }

  .view-unchecked .el-checkbox {
    opacity: 0.5;
    border: 0;
    background: transparent;
  }

  @media (max-width: 991.98px) {
    .el-checkbox.is-bordered {
      padding: 9px 20px 9px 10px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: normal;
      width: 100% !important;
      white-space: normal !important;
      height: auto !important;
      display: flex !important;
    }
  }

  .el-checkbox.is-bordered {
    height: 34px !important;
    border: none !important;
  }
</style>
